import { Box, Notification, TextLink, Typography } from "@drone-js/core";
import { VStack } from "apps/commons/components/Stack";
import { substitute } from "apps/commons/functions/substitute";
import { usePropertySelectionViewModelValue } from "apps/propertySelection/propertySelectionViewModelAtom";
import type { ExtendedScrapingErrorResponseErrorTypeEnum } from "libs/codegen/property-onboarding";
import { memo } from "react";
import { scrapingErrorResponseMapper } from "../scrapingErrorResponseMapper";

interface Props {
    errorType: ExtendedScrapingErrorResponseErrorTypeEnum;
    onLearnMore: () => void;
}

export const IncorrectUrlNotification = memo<Props>(({ errorType, onLearnMore }) => {
    const {
        inputUrlCms: {
            incorrectAirbnbLink,
            incorrectBookingLink,
            goToSite,
            openListingPage,
            copyListingLink,
            toCopyTheCorrectLink,
            learnMore,
        },
    } = usePropertySelectionViewModelValue();

    const isAirbnb = errorType === scrapingErrorResponseMapper.IncorrectAirbnbUrl;

    return (
        <Notification
            intent="error"
            asset={{
                id: "fill.symbol.triangle-exclamation",
            }}
            title={isAirbnb ? incorrectAirbnbLink : incorrectBookingLink}
            actions={[
                {
                    label: learnMore,
                    onClick: onLearnMore,
                    "data-element-name": "learn-more-button",
                },
            ]}
            description={
                <VStack gap="2">
                    <Typography variant="body-s">{toCopyTheCorrectLink}</Typography>
                    <Box as="ol" ps="12" m="0">
                        <li>
                            {substitute(goToSite, {
                                0: isAirbnb ? (
                                    <TextLink
                                        label="Airbnb.com"
                                        href="https://airbnb.com"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    />
                                ) : (
                                    <TextLink
                                        label="Booking.com"
                                        href="https://booking.com"
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    />
                                ),
                            })}
                        </li>
                        <li>{openListingPage}</li>
                        <li>{copyListingLink}</li>
                    </Box>
                </VStack>
            }
        />
    );
});
